import React, { FC } from 'react';

export const IconCheck: FC<React.PropsWithChildren<{ className?: string }>> = ({ className }) => (
  <svg className={className} width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5.8L4.36842 9L11.6667 1" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
